function dataAdapter (res) {
  return res.json().then((body) => {
    const newRes = {
      ...res,
      body
    }
    if (!res.ok) {
      throw newRes.body || newRes
    }
    return newRes
  })
}

export default {
  getReferralRelationList (path) {
    return fetch(path, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(dataAdapter)
  },

  getDataViaApi (path) {
    const headerObject = { 'Cache-Control': 'no-cache' }
    return fetch(path, {
      method: 'GET',
      headers: headerObject
    }).then(dataAdapter)
  },

  uploadFile (path, formData) {
    return fetch(path, {
      method: 'POST',
      body: formData
    }).then(dataAdapter)
  },

  postDataViaApi (path, body) {
    return fetch(path, {
      method: 'POST',
      body: JSON.stringify(body),
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(dataAdapter)
  },

  deleteDataViaApi (path) {
    return fetch(path, {
      method: 'DELETE'
    }).then(dataAdapter)
  },

  putDataViaApi (path, data) {
    return fetch(path, {
      method: 'PUT',
      body: data
    }).then(dataAdapter)
  }
}
